import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import { getValueFromQueryString } from '../../helpers';
import auth from '../../auth';
import paymentTransaction from '../../Actions/paymentTransaction';
import {pageGA } from '../../Helpers/GoogleAnalytics';
const { applyPaymentTransaction, applyUserPaymentTransaction } = paymentTransaction.actions;

class FinishRegistration extends Component {
    componentDidMount() {
        const transactionId = getValueFromQueryString('idTransaction');
        const isUser = getValueFromQueryString('isUser');
        const { packageToBuy } = this.props;
        if (transactionId) {
            if(isUser === 'true') {
                this.props.applyUserPaymentTransaction({ transactionId, packageToBuy, history: this.props.history });
            } else {
                this.props.applyPaymentTransaction({ transactionId, packageToBuy, history: this.props.history });
            }
        } else {
            if(auth.isAuthenticated()) {
                this.props.history.push('/license');
            } else {
                window.location.href = '/';
            }
        }
		pageGA()
    }

    render() {
        return (
            <div className="loading-container">
                <Spin size="large" tip="Cargando" />
            </div>
        )
    }
}

const mapStateToProps = state => {
    console.log('state ', state);    
    return {        
        packageToBuy: state.register.packageToBuy
    }
}

const mapDispatchToProps = dispatch => {
    return {       
        applyPaymentTransaction(data) {
            dispatch(applyPaymentTransaction(data));
        },
        applyUserPaymentTransaction(data) {
            dispatch(applyUserPaymentTransaction(data));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishRegistration);